/**
 * Clears persisted project selection used across the portal.
 * Stale ProjectId / selectedProjectCode after access removal can cause
 * repeated 403 → /securitycheck → Try Again → home → 403 loops.
 */
export const SELECTED_PROJECT_CODE_KEY = 'selectedProjectCode';
export const PROJECT_ID_KEY = 'ProjectId';
export const CURRENT_FILES_PROJECT_ID_KEY = 'CurrentFilesProjectId';
export const CURRENT_PROJECT_PUBLISH_DATE_KEY = 'CurrentProjectPublishDate';

export function clearSelectedProjectStorage() {
	if (typeof window === 'undefined') {
		return;
	}

	try {
		localStorage.removeItem(PROJECT_ID_KEY);
		localStorage.removeItem(CURRENT_FILES_PROJECT_ID_KEY);
		localStorage.removeItem(CURRENT_PROJECT_PUBLISH_DATE_KEY);
		sessionStorage.removeItem(SELECTED_PROJECT_CODE_KEY);
	} catch (e) {
		// Storage may be unavailable (private mode / blocked); ignore.
	}
}
